import { PromoCode } from "core/types";
import { Table } from "../../../Table";

import { usePromocodesColumns } from "./usePromocodesColumns";

type PromoCodesTableProps = {
  source: PromoCode[];
};

export const PromoCodesTable = ({ source }: PromoCodesTableProps) => {
  const { data, columns } = usePromocodesColumns(source);

  return <Table data={data} columns={columns} />;
};
